import { render, staticRenderFns } from "./AAsignacionByPrograma.vue?vue&type=template&id=5cc8b5fc"
import script from "./AAsignacionByPrograma.vue?vue&type=script&lang=js"
export * from "./AAsignacionByPrograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports